(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-navigation"] && !Shopify.designMode) return;
  try {
    const h2Targets = [];

    // 将 blogContent 相关逻辑移出全局作用域或使其更健壮
    let blogContent = null;

    // 在 DOMContentLoaded 事件内部重新获取元素，确保它们存在
    document.addEventListener('DOMContentLoaded', function() {
        // 获取博客内容容器
        blogContent = document.querySelector('.blog-post-content');

        // 收集所有导航链接和目标元素
        document.querySelectorAll('[data-target]').forEach(link => {
            const targetId = link.getAttribute('data-target');
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                h2Targets.push({
                    link: link,
                    element: targetElement,
                    offsetTop: targetElement.offsetTop // 这个值依赖于元素渲染完成
                });
            }
        });

        // 初始化：检查一次当前激活项
        updateActiveLink();

        // 将事件监听器添加到 DOMContentLoaded 内部，确保元素已就位
        window.addEventListener('scroll', updateActiveLink);
        window.addEventListener('resize', updateActiveLink);
    });

    function updateActiveLink() {

        // 始终尝试更新活动链接，如果 h2Targets 存在的话
        if (h2Targets.length === 0) return;

        const scrollPosition = window.scrollY + 100; // 使用 window.pageYOffset 或 window.scrollY
        let activeTarget = null;

        // 找到当前视口顶部最接近的 h2 目标
        for (let i = h2Targets.length - 1; i >= 0; i--) {
            if (scrollPosition >= h2Targets[i].offsetTop) {
                activeTarget = h2Targets[i];
                break;
            }
        }

        // 移除所有链接的 'active' 类
        document.querySelectorAll('#h2Nav a').forEach(a => a.classList.remove('active'));

        // 给当前活跃的链接添加 'active' 类
        if (activeTarget) {
            activeTarget.link.classList.add('active');
        }
    }


    // 为目录中的链接添加平滑滚动功能
    document.querySelectorAll('#h2Nav a').forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1); // 获取 ID (去掉 #)
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // 计算滚动位置（可以加上顶部偏移，例如导航栏高度）
                const targetPosition = targetElement.offsetTop;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
  } catch(e) { console.error(e); }
})();

})();
